import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider } from './hooks/useAdminAuth';
import { AdminLayout } from './components/layout/AdminLayout';
import { LoginPage } from './pages/auth/LoginPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { UsersPage } from './pages/users/UsersPage';
import { UserDetailPage } from './pages/users/UserDetailPage';
import { WorkspacesPage } from './pages/workspaces/WorkspacesPage';
import { WorkflowsPage } from './pages/workflows/WorkflowsPage';
import { WorkflowHealthPage } from './pages/workflows/WorkflowHealthPage';
import { IntegrationsPage } from './pages/integrations/IntegrationsPage';
import { SystemPage } from './pages/system/SystemPage';
import { MonitoringPage } from './pages/monitoring/MonitoringPage';
import { FastAPIMonitoringPage } from './pages/monitoring/FastAPIMonitoringPage';
import { InvoicesPage } from './pages/invoices/InvoicesPage';
import { PricingPage } from './pages/pricing/PricingPage';
import { PhoneNumbersPage } from './pages/phone-numbers/PhoneNumbersPage';
import { CallingProvidersPage } from './pages/calling-providers/CallingProvidersPage';
import { ApiKeysPage } from './pages/api-keys/ApiKeysPage';
import { ProtectedRoute } from './components/auth/ProtectedRoute';

function App() {
  return (
    <AdminAuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/admin/login" element={<LoginPage />} />
          
          {/* Protected admin routes */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:userId" element={<UserDetailPage />} />
            <Route path="workspaces" element={<WorkspacesPage />} />
            <Route path="pricing" element={<PricingPage />} />
            <Route path="invoices" element={<InvoicesPage />} />
            <Route path="phone-numbers" element={<PhoneNumbersPage />} />
            <Route path="calling-providers" element={<CallingProvidersPage />} />
            <Route path="api-keys" element={<ApiKeysPage />} />
            <Route path="workflows" element={<WorkflowsPage />} />
            <Route path="workflow-health" element={<WorkflowHealthPage />} />
            <Route path="integrations" element={<IntegrationsPage />} />
            <Route path="system" element={<SystemPage />} />
            <Route path="monitoring" element={<MonitoringPage />} />
            <Route path="fastapi-monitoring" element={<FastAPIMonitoringPage />} />
          </Route>
          
          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/admin/login" replace />} />
          <Route path="*" element={<Navigate to="/admin/login" replace />} />
        </Routes>
      </Router>
    </AdminAuthProvider>
  );
}

export default App;






















